import { lazy } from "react";

export const WhizLayouts = { layout1: lazy(() => import("./Layout1/Layout1")) };
